function getSearchURLParams(url)
{
    if(typeof url !== "string") {
        return {};
    }
   var urlSplit = url.split("?");
   if(urlSplit.length < 2) {
       return {};
   }
   return _.object(_.map(urlSplit[1].split("&"), function(params) {
       return params.split("=");
   }));
}
var jQuery = require("jQuery");
function getSuitelet(script, deploy) {
   return {"customscript_ns_sc_ext_sl_orderstatus_of:customdeploy_ns_sc_ext_sl_orderstatus_of":"/app/site/hosting/scriptlet.nl?script=625&deploy=1&compid=689066&ns-at=AAEJ7tMQSekb1A-CI0DN59hCFzWcT_AFMf0z68IrEM2di2EG_TU","customscript_ns_sc_sl_blog_entity_loader:customdeploy_ns_sc_sl_blog_entity_loader":"/app/site/hosting/scriptlet.nl?script=595&deploy=1&compid=689066&ns-at=AAEJ7tMQgmMVpre0kWbX_Q1sgRD_U-Ohnj8i0u-poF8Ou964Btk","customscript_ns_sc_sl_blog_post_searcher:customdeploy_ns_sc_sl_blog_post_searcher":"/app/site/hosting/scriptlet.nl?script=597&deploy=1&compid=689066&ns-at=AAEJ7tMQTkKbXbnjOrg2ibaCj7Ro5IlDSPxYvSYkUEg8Y3Ux0C4","customscript_ns_sc_sl_blog_url_prov:customdeploy_ns_sc_sl_blog_url_prov_dep":"/app/site/hosting/scriptlet.nl?script=596&deploy=1&compid=689066&ns-at=AAEJ7tMQToBi8GNmHxu8ciGtL19yQnvhA9zDv1r0yB8dJrJ6dXM","customscript_ns_sc_sl_gift_cert_balance:customdeploy_ns_sc_sl_gift_cert_balance":"/app/site/hosting/scriptlet.nl?script=608&deploy=1&compid=689066&ns-at=AAEJ7tMQH_c9W2HOtn1ZSHXMMgPvrb38dTOSHXVWsA1NkHIdzvY","customscript_ns_sc_sl_gift_cert_groups:customdeploy_ns_sc_sl_gift_cert_groups":"/app/site/hosting/scriptlet.nl?script=607&deploy=1&compid=689066&ns-at=AAEJ7tMQ8X4GALgB2ZjMTb0MffvuWiHOT3KvpJkX6TjKGfOWpGI","customscript_ns_sc_sl_gift_cert_mgmt:customdeploy_ns_sc_sl_gift_cert_mgmt":"/app/site/hosting/scriptlet.nl?script=609&deploy=1&compid=689066&ns-at=AAEJ7tMQ3k-h167oSRxVhG3G9oexbwn95lZEUPJXuUAg3K9vgGA","customscript_ns_sc_sl_itembadges:customdeploy_ns_sc_sl_itembadges":"/app/site/hosting/scriptlet.nl?script=619&deploy=1&compid=689066&ns-at=AAEJ7tMQkBTcmNiosfmFlH7SMgzGW2P3QvtFIVzkJ03FNynjuds"}[script + ":" + deploy];
}
var xhrFactory = jQuery.ajaxSettings.xhr;
jQuery.ajaxSettings.xhr = function() {
   var xhr = xhrFactory.apply(this, arguments);
   var open = xhr.open;
   xhr.open = function () {
        var url = arguments[1];
        var assocParams = getSearchURLParams(url);
        if(assocParams.hasOwnProperty("script") && assocParams.hasOwnProperty("deploy")) {
            var hashed = getSuitelet(assocParams["script"], assocParams["deploy"]);
            if(hashed) {
                var hashedParams = getSearchURLParams(hashed);
                var keys = Object.keys(assocParams);
                for (var i=0; i<keys.length; i++) {
                    var key = keys[i];
                    var value = assocParams[key];
                    if(!hashedParams.hasOwnProperty(key))
                    {
                        hashed += "&" + key + "=" + value;
                    }
                }
                arguments[1] = hashed;
            }
        }
        return open.apply(this, arguments);
    }
    return xhr;
}